<template>
  <!-- 舆情-新增-舆情概况 -->
  <div class="add_negative">
    <div class="content">
      <div class="accident">
        <div class="tip">审核扣分</div>
        <div class="input">
          <van-field
            v-model="value"
            :formatter="formatter"
            autosize
            type="number"
            :placeholder="`请输入扣分分数（≤${maxScore}）`"
            show-word-limit
          />
        </div>
      </div>
      <div class="dedust_reason">
        <div class="title">扣分原因</div>
        <div class="cont">
          <!-- <van-field
            v-model="message"
            rows="5"
            autosize
            autofocus
            type="textarea"
            maxlength="500"
            placeholder="请输入扣分原因"
            show-word-limit
          />-->
          <div class="about_content">
            <textarea
              class="contentmemo"
              placeholder="请输入扣分原因"
              maxlength="500"
              v-model="message"
              @input="change"
            ></textarea>
            <span class="total">{{currentTotal}}/500</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bot_btns">
      <van-button @click="nextStep" type="primary" size="large">保存</van-button>
    </div>

    <tipDialog
      v-if="isShowTipDialog"
      :content="tipDialogContent"
      @closeModal="isShowTipDialog = false"
    ></tipDialog>
  </div>
</template>

<script>
import API from "@/service/modules/appraiseNewWzy.js";
import tipDialog from "./components/tipDialog.vue";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
export default {
  components: {
    tipDialog,
  },
  data() {
    return {
      show: false,
      isShowTipDialog: false,
      tipDialogContent: "",
      detailQuery: {
        id: "",
        integrityType: "",
      },
      value: "",
      message: "",
      currentTotal:0
    };
  },
  created() {
    /** 获取参数 **/
    this.detailQuery = this.$route.query;
  },
  computed: {
    maxScore() {
      switch (this.detailQuery.integrityType) {
        case "C1":
        case "C3":
          return "3";
          break;
        case "C2":
          return "5";
          break;
        case "C4":
          return "2";
          break;
        default:
          return "0";
      }
    },
  },
  methods: {
    // 保存
    async nextStep() {
      if (!this.value) {
        this.isShowTipDialog = true;
        this.tipDialogContent = "请输入审核扣分";
        return;
      } else if (!this.message) {
        this.isShowTipDialog = true;
        this.tipDialogContent = "请输入扣分原因";
        return;
      } else if (
        (this.detailQuery.integrityType == "C1" ||
          this.detailQuery.integrityType == "C3") &&
        this.value > 3
      ) {
        this.isShowTipDialog = true;
        this.tipDialogContent = "扣分需≤3分";
        return;
      } else if (this.detailQuery.integrityType == "C2" && this.value > 5) {
        this.isShowTipDialog = true;
        this.tipDialogContent = "扣分需≤5分";
        return;
      } else if (this.detailQuery.integrityType == "C4" && this.value > 2) {
        this.isShowTipDialog = true;
        this.tipDialogContent = "扣分需≤2分";
        return;
      }
      const res = await API.auditIntegrity({
        ...this.detailQuery,
        deduction: this.value * 100,
        deductionReason: this.message,
      });
      if (res.ret === 0) {
        this.$Toast({
          message: "保存成功",
          icon,
        });
        setTimeout(() => {
          this.$router.back(-1);
        }, 1000);
      }
    },
     change() {
      this.currentTotal = this.message.trim().length;
    },
    formatter(value) {
      let a = value
        .replace(/[^\d.]/g, "")
        .replace(/\.{2,}/g, ".")
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3")
        .replace(/^\./g, "");
      return a;
    },
  },
};
</script>

<style scoped lang="less">
.content {
  padding: 0 12px;
}
.accident {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  height: 46px;
  border-bottom: 1px solid #ededed;
  .tip {
    color: #666;
    font-size: 14px;
  }
  .input .van-field {
    width: 250px;
    padding: 0px;
    /deep/ input {
      text-align: right;
    }
    /deep/ input::-webkit-input-placeholder {
      font-size: 14px;
      color: #ccc;
      text-align: right;
    }
  }

  .drop_down {
    span {
      margin-right: 4px;
      color: #ccc;
      font-size: 14px;
    }
    img {
      display: inline-block;
      width: 12px;
      height: 12px;
      vertical-align: text-top;
    }
  }
}
.bot_btns {
  padding: 16px 12px;
  // height: 60px;
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
  .van-button {
    width: 351px;
    height: 40px;
    background-color: #36b374;
  }
}
.dedust_reason {
  padding: 4px 0 0;
  .title {
    padding: 12px 0;
    font-size: 14px;
    color: #666;
  }
  .cont .van-field {
    padding: 16px 12px;
    height: 180px;
    background-color: #f5f5f5;
    /deep/ .van-field__body {
      height: 120px;
      overflow: auto;
      textarea {
        padding-top: 16px;
        height: 120px;
      }
    }
    /deep/ .van-field__word-limit {
      margin-top: 18px;
      color: #333;
      font-size: 14px;
      span {
        color: #999;
      }
    }
  }
  .cont{
    overflow: hidden;
  }
  .about_content {
    width: 100%;
    position: relative;
    padding: 15px 12px 28px 12px;
    background-color: #f5f5f5 ;
    .contentmemo {
      width: 100%;
      height: 180px;
      font-size: 14px;
      color: #323233;
      background-color: #f5f5f5;
      outline: none;
      border: none;
      resize: none;
      border-radius: 3px;
      // padding: 16px;
      // box-sizing: border-box;
      // line-height: 1.3em;
      line-height: 20px;
      padding: 1px 0;
      margin-top: -1px;
      overflow: auto;
    }
    .total {
      position: absolute;
      bottom: 8px;
      right: 8px;
      font-size: 14px;
      color: #323233;
    }
  }
}
</style>
